import { render, staticRenderFns } from "./UserGroupInfo.vue?vue&type=template&id=d42d0fb0&scoped=true"
import script from "./UserGroupInfo.vue?vue&type=script&lang=js"
export * from "./UserGroupInfo.vue?vue&type=script&lang=js"
import style0 from "./UserGroupInfo.vue?vue&type=style&index=0&id=d42d0fb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42d0fb0",
  null
  
)

export default component.exports